import { useCallback } from 'react'
import { useFamily } from '@/context/FamilyContext'
import { BranchingStoryPlayer } from '@/components/storytelling/BranchingStoryPlayer'
import { getBranchingStory } from '@/data/branching-stories'
import { saveSession } from '@/services/branchingStoryService'

export function BranchesPlayground() {
  const { activeWriter } = useFamily()
  const story = getBranchingStory('the-mysterious-door')

  const handleComplete = useCallback(
    async (path: string[]) => {
      if (!activeWriter || !story) return
      await saveSession(activeWriter.id, story.id, path)
    },
    [activeWriter, story]
  )

  if (!story) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <p style={{ color: 'var(--color-story-text-muted)' }}>Story not found.</p>
      </div>
    )
  }

  return (
    <div>
      <div className="px-5 py-4" style={{ background: 'linear-gradient(135deg, var(--color-story-primary), var(--color-story-primary-light))' }}>
        <div className="max-w-lg mx-auto">
          <p className="text-xs text-white/70 uppercase tracking-wide">Story Playground</p>
          <p className="text-lg font-bold text-white">{story.title}</p>
          <p className="text-sm text-white/80 mt-1">{story.description}</p>
        </div>
      </div>
      <BranchingStoryPlayer story={story} onComplete={handleComplete} />
    </div>
  )
}
